import getWindow from '../../../utils/getWindow';
import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH } from 'nav-meta/constants';
export const getBoundaryDimensions = () => {
  const {
    innerHeight,
    innerWidth
  } = getWindow();
  const bottomOfGlobalToolbar = getComputedStyle(document.documentElement).getPropertyValue('--global-nav-height');
  const verticalNavRightEdge = getComputedStyle(document.documentElement).getPropertyValue('--global-nav-vertical-nav-width');
  const buffer = 4;
  const top = (bottomOfGlobalToolbar ? parseInt(bottomOfGlobalToolbar, 10) : 44) + buffer;
  const bottom = innerHeight - buffer;
  const left = (verticalNavRightEdge ? parseInt(verticalNavRightEdge, 10) : parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH, 10)) + buffer;
  return {
    top,
    bottom,
    height: bottom - top,
    width: innerWidth - left
  };
};
export const getSecondaryMenuWindowDimensions = ({
  secondaryMenuRef
}) => {
  let dimensions = {
    top: 0,
    bottom: 0,
    height: 0,
    width: 0
  };
  if (!secondaryMenuRef.current) return dimensions;
  const currentTransformStyle = secondaryMenuRef.current.style.transform;
  secondaryMenuRef.current.style.transform = 'none'; // remove the transform temporarly to get the original dimensions

  const secondaryNavItemDimensions = secondaryMenuRef.current.getBoundingClientRect();
  secondaryMenuRef.current.style.transform = currentTransformStyle;
  const top = secondaryNavItemDimensions.y;
  dimensions = {
    top,
    bottom: top + secondaryNavItemDimensions.height,
    height: secondaryNavItemDimensions.height,
    width: secondaryNavItemDimensions.width
  };
  return dimensions;
};